import { formatDate } from '@payflip/utils';
import { Heading } from '../../heading';
import { Paragraph } from '../../paragraph';
import { Amount } from '../../_atoms';
import { StyledFlexColumn, StyledTransactionTile } from './styled';

interface TransactionTileProps {
  amount: number;
  title: string;
  date: Date | string;
}

export function TransactionTile({
  amount,
  title,
  date
}: TransactionTileProps): JSX.Element {
  return (
    <StyledTransactionTile>
      <StyledFlexColumn>
        <Heading variant="h5">{title}</Heading>
        <Paragraph lighter variant="small">
          {formatDate(date)}
        </Paragraph>
      </StyledFlexColumn>
      <StyledFlexColumn>
        <Paragraph semiBold>
          <Amount amount={amount} signed={false} />
        </Paragraph>
      </StyledFlexColumn>
    </StyledTransactionTile>
  );
}
